(function (appComponents) {

    //clean the whole service
    appComponents.services.helpers = function (Components) {

        var helpers = {};

        helpers.name = "helpers";

        Components.getComponentPrototype().extend(helpers);

        helpers.pagerFactory = helpers._getPageComponent("pagerFactory");

        helpers.elements = {
            getCountries: function (type) {
                if (type == "dropship") {
                    return $('[pc-container="helpers--countries-dropship"]');

                }
                return $('[pc-container="helpers--countries"]');
            },
            get states() {
                return $('[pc-container="helpers--states"]');
            },
            getSpanForCharCountdown: function (textAreaName) {
                return $('[pc-container="helpers--span-char-countdown-' + textAreaName + '"]');
            },
            get charCountdown() {
                return $('[pc-filter--char-countdown]');
            }

        };

        helpers.bindings = function () {

            // index page up-down arrow
            helpers._elements.body.on("click", '.pc-back-to-bottom-top', function () {
                var countClick = $(this).data('clicked');
                $(this).find('i').toggleClass('fa-angle-down fa-angle-up');
                if (countClick) {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 1200);
                } else {
                    $('html, body').animate({
                        scrollTop: helpers._elements.document.height()
                    }, 1200);
                }
                $(this).data("clicked", !countClick);
            });

            // sticky filters bs
            helpers._elements.document.on("scroll", function (evt) {
                if (helpers._elements.document.width() <= 749) return;

                var stickyFilters = $('[pc-sticky]');

                if (!stickyFilters.length) return;

                stickyFilters.each(function () {

                    var filterInitOffset = $(this).attr("init-offset");
                    var auxValueToOffset = $(this).attr("pc-sticky-aux-value-to-offset") ? parseInt($(this).attr("pc-sticky-aux-value-to-offset")) : 0;

                    if (!filterInitOffset) {
                        filterInitOffset = $(this).offset().top;
                        $(this).attr("init-offset", filterInitOffset);
                    }

                    var currentScrollPosition = $(window).scrollTop();

                    // state 1
                    if (currentScrollPosition <= filterInitOffset - helpers._elements.header.height()) {
                        $(this).css({
                            top: 0
                        });
                    }

                    // state 2
                    if (currentScrollPosition + 6 > filterInitOffset - helpers._elements.header.height() - auxValueToOffset && $(this).offset().top + $(this).outerHeight() < helpers._elements.footer.offset().top) {

                        $(this).offset({
                            top: currentScrollPosition + helpers._elements.header.height() + 10 + auxValueToOffset
                        });
                    }

                    // state 3
                    if ($(this).offset().top + $(this).outerHeight() >= helpers._elements.footer.offset().top) {
                        $(this).offset({
                            top: helpers._elements.footer.offset().top - $(this).outerHeight() - 1
                        });
                    }
                });

            });

            //validation for quantity
            helpers._elements.body.off("keypress", 'input[pc-filter--qty]').on("keypress", 'input[pc-filter--qty]', function (evt) {
                evt = evt || window.event;
                var charCode = evt.which || evt.keyCode;
                if (helpers.crossValidationReg(charCode, /[^\d]/, this.value.length, 3) != undefined) return false;
            });
            helpers._elements.body.on("blur", 'input[pc-filter--qty]', function () {
                var minQty = parseInt($(this).attr('min'));
                if (this.value < minQty) {
                    this.value = minQty;
                }
            });

            //validation for number
            helpers._elements.body.on("keypress", 'input[pc-filter--float-num-only]', function (evt) {
                evt = evt || window.event;
                var charCode = evt.which || evt.keyCode;
                if (helpers.crossValidationReg(charCode, /[^\d.]/) != undefined) return false;
            });
            helpers._elements.body.on("keypress", 'input[pc-filter--float-num-only]', function (evt) {
                evt = evt || window.event;
                var charCode = evt.which || evt.keyCode;
                if (helpers.crossValidationReg(charCode, /[^\d.]/) != undefined) return false;
            });
            //validation for phone
            helpers._elements.body.on("keypress", 'input[pc-filter--phone]', function (evt) {
                evt = evt || window.event;
                var charCode = evt.which || evt.keyCode;
                if (helpers.crossValidationReg(charCode, /[^\d+]/) != undefined) return false;
            });

            //validation for ZIP
            helpers._elements.body.on("keypress", 'input[pc-filter--lat-num]', function (evt) {
                evt = evt || window.event;
                var charCode = evt.which || evt.keyCode;
                if (helpers.crossValidationReg(charCode, /[?-??-???????@%^&*+=_!~:`?;()\\|?"$']/) != undefined) return false;
            });
            
            //Validation for Ship address  
            helpers._elements.body.on("keypress", 'input[pc-filter--ship-add]', function (evt) {
                    evt = evt || window.event;
                    var charCode = evt.which || evt.keyCode;
                  //  if (helpers.crossValidationAdd(charCode, /[a-zA-Z0-9]/) != undefined) return false;
                });
            //Validation for Ship address name 
            helpers._elements.body.on("keypress", 'input[pc-filter--ship-add--name]', function (evt) {
                    evt = evt || window.event;
                    var charCode = evt.which || evt.keyCode;
                   // if (helpers.crossValidationAddName(charCode, /[a-zA-Z0-9]/) != undefined) return false;
                });
           
            //Validation for PO number
                helpers._elements.body.on("keydown", 'input[pc-filter--po-num]', function (evt) {
                    evt = evt || window.event;
                    var charCode = evt.which || evt.keyCode;
                    var key = evt.key;
                 //   if (helpers.crossValidationPO(charCode,/[a-zA-Z0-9#.,-]/, key) != undefined) return false;
                    
                });
            
            //Text-transform for field "Customer Index No."
            helpers._elements.body.on("blur", "[pc-container='helpers--to-upper-case']", function () {
                this.value = this.value.toLocaleUpperCase();
            });

            // clear form on modal close
            helpers._elements.body.on('hide.bs.modal', function (e) {
                var formToClear = $(e.target).find("form[pc-filter--clear-modal-form]");
                if (formToClear.length == 0)
                {
                	 var feedbackForm = $(e.target).find("form[pc-filter--clear-feedback-form]");
                	 if(feedbackForm.length == 0)
                		 return;
                	 else
                		 feedbackForm.find('textarea').val('');
                	 	 return;
                }

                formToClear.find('input:checked + .iCheck-helper').click();
                formToClear.find('select').val('').trigger("change");
                formToClear.find('select[pc-container="helpers--states"]').empty().trigger("change");
                formToClear.find('input:visible').not("input[type='checkbox']").val('');
                formToClear.find('textarea').val('');
            });

            helpers._elements.body.on("keyup", '[pc-filter--char-countdown]', function () {

                var maxValue = parseInt($(this).attr("maxlength"));
                var closestSpan = helpers.elements.getSpanForCharCountdown(this.name);

                closestSpan.text(maxValue - this.value.length);
            });


            helpers._elements.body.on("change", '[pc-container="helpers--countries"], [pc-container="helpers--countries-dropship"]', function () {
                var countryIso = $(this).val();
                if (!countryIso) return;
                helpers.handlers.onCountryChange(countryIso);
            });
            //Added for storelocator countries state dropdown
            helpers._elements.body.on("change", '[pc-container="helpers--countries-new"]', function () {
                var countryIso = $(this).val();
                if (!countryIso) return;
                helpers.handlers.onCountryChange(countryIso);
            });

            helpers._elements.body.on("change", "[pc-container='helpers--date-from']", function () {
                var val = this.value;
                $("[pc-container='helpers--date-range']").find("[pc-container='helpers--date-to']").datepicker("destroy").datepicker({
                    startDate: new Date(val),
                    orientation: "bottom",
                    autoclose: true
                });
            });

            helpers._elements.body.on("change", "[pc-container='helpers--date-to']", function () {
                var val = this.value;
                $("[pc-container='helpers--date-range']").find("[pc-container='helpers--date-from']").datepicker("destroy").datepicker({
                    endDate: new Date(val),
                    orientation: "bottom",
                    autoclose: true
                });
            });

            // hacks to align some 3rd party plugins with each other
            $.fn.modal.Constructor.prototype.enforceFocus = function () {};

            helpers._elements.document.on('shown.bs.modal', function () {
                $(".modal-body").niceScroll({
                    autohidemode: false,
                    cursorcolor: "#0996c3"
                });
            });

            helpers._elements.document.on('DOMNodeInserted', function (e) {
                if ($(e.target).hasClass("select2-container--open")) {
                    $(e.target).css("z-index", "9999");
                }
            });

            // from td core
            helpers._elements.body.on('click', '.show-more', function () {
                $(this).closest('.cart-details-grid').find('.hidden-row').toggleClass('dis-none');
                if ($(this).text() == "Show More")
                    $(this).text("Show Less");
                else
                    $(this).text("Show More");
            });

            helpers._elements.body.on('ifChecked', 'input[type="radio"]', function () {
                $(this).closest('.radio-class').find('label').addClass("text-bold");
            });

            helpers._elements.body.on('ifUnchecked', 'input[type="radio"]', function () {
                $(this).closest('.radio-class').find('label').removeClass("text-bold");
            });

            helpers._elements.body.on('click', '.pro-desc', function () {
                $(this).next('.pro-desc-details').toggleClass('dis-none');
                $(this).find(".fa").toggleClass('fa-plus fa-minus');
            });

            helpers._elements.body.on('click', '.panel-heading a', function () {
                $(".acc-wizard-todo").removeClass("acc-wizard-active");
            });

        };

        helpers.crossValidationReg = function (charCode, regex, valueL, limit) {
            var charStr = String.fromCharCode(charCode);
            switch (charCode) {
                case 8:
                case 32:
                case 35:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 46:
                    break;
                default:
                    if (limit) {
                        if (valueL > limit - 1) {
                            return false;
                        } else {
                            if (regex.test(charStr)) {
                                return false;
                            }
                        }
                    } else {
                        if (regex.test(charStr)) {
                            return false;
                        }
                    }
                    break;
            }
        };
        helpers.crossValidationPO = function (charCode, regex, key, valueL, limit) {
            var charStr = String.fromCharCode(charCode);
            var len = ($("#customer-num").val()).length;
            var input_po_string = $("#customer-num").val();
             switch (key) {
                /*case 8:
                case 32:
                case 35:
                case 44:
                case 45:
                case 46:*/
                case "!":
                case "@":
                case "$":
                case "%":
                case "^":
                case "&":
                case "*":
                case "(":
                case ")":
                	$("#po_error_msg").show();
              		$("#customer-num").addClass("pc-error-field");
              		return false;
                case "Tab":
                case "ArrowUp":
                case "ArrowDown":
                case "ArrowRight":
                case "ArrowLeft":
                case " #":
                case ".":
                case ",":
                case "-":
                case " ":
                	
                	if (len >= 30) {
                		  $("#po_error_msg").hide();
                    	$("#po_max_len_msg").show();
                    	$("#customer-num").addClass("pc-error-field");
                     	$("#bill-info-btn").attr("disabled",true);
                    	
                    }else if(len <30){
                    	$("#po_error_msg").hide();
                    	$("#po_max_len_msg").hide();
                    	$("#customer-num").removeClass("pc-error-field");
                     	$("#bill-info-btn").removeAttr("disabled");
                    }
                	  
                	
                    break;
               case "Backspace":
                	
                	if (len > 31) {
                		  $("#po_error_msg").hide();
                    	$("#po_max_len_msg").show();
                    	$("#customer-num").addClass("pc-error-field");
                     	$("#bill-info-btn").attr("disabled",true);
                    	
                    }else if(len <= 31){
                    	$("#po_error_msg").hide();
                    	$("#po_max_len_msg").hide();
                    	$("#customer-num").removeClass("pc-error-field");
                     	$("#bill-info-btn").removeAttr("disabled");
                    }
                	  
                	
                    break;
                default:
                	
                    if (len >= 30) {
                        	$("#po_max_len_msg").show();
                        	$("#customer-num").addClass("pc-error-field");
                        	$("#bill-info-btn").attr("disabled",true);
                        	
                        } else {
                        	
                        	$("#customer-num").removeClass("pc-error-field");
                        	if (!regex.test(charStr)) {
                          		$("#po_error_msg").show();
                          		$("#customer-num").addClass("pc-error-field");
                          		
                              return false;
                        }else{
                        	$("#po_error_msg").hide();
                        	$("#po_max_len_msg").hide();
                        	$("#customer-num").removeClass("pc-error-field");
                        	$("#bill-info-btn").removeAttr("disabled");
                        }    }
                  
                    break;
            }
              
        };
        /*helpers.crossValidationAdd = function (charCode, regex, valueL, limit) {
            var charStr = String.fromCharCode(charCode);
               switch (charCode) {
                case 8:
                case 32:
                case 44:
                case 45:
                             
                    break;
                default:
                     
                	
                	$("#address").removeClass("pc-error-field");
                	if (!regex.test(charStr)) {
                          		$("#add_err_msg_address").show();
                          		
                          		$("#address").addClass("pc-error-field");
                            return false;
                        }
                	else{
                		$("#add_err_msg_address").hide();
                    	$("#address").removeClass("pc-error-field");
                      }
                    break;
            }
        };
        
        helpers.crossValidationAddName = function (charCode, regex, valueL, limit) {
            var charStr = String.fromCharCode(charCode);
               switch (charCode) {
                case 8:
                case 32:
                case 44:
                case 45:
                             
                    break;
                default:
                     
                	$("#name").removeClass("pc-error-field");
                	
                	if (!regex.test(charStr)) {
                          		$("#add_err_msg_name").show();
                          		$("#name").addClass("pc-error-field");
                          		
                            return false;
                        }
                	else{
                		$("#add_err_msg_name").hide();
                    	$("#name").removeClass("pc-error-field");
                      }
                    break;
            }
        };*/

        helpers.checkFormForErrors = function (form) {
            var hasErrors = false;
            $(form).find(".pc-error-field").removeClass("pc-error-field");
  /*           var state=$('#wby-drop-city').val();
            if (state == "") {
            	 hasErrors = true;
            	 $('#wby-drop-city').siblings(".select2-container").addClass("pc-error-field");
            } */
            $(form).find("[pc-required-field]:visible").each(function (idx, el) {
                var trimmedValue = $(el).val().trim();
                $(el).val(trimmedValue);
                if (trimmedValue == "") {
                    var tag = $(el).prop("tagName");
                    if (tag == "SELECT") {
                        $(el).siblings(".select2-container").first().find(".select2-selection").addClass("pc-error-field");
                    }
                    if (tag == "INPUT") {
                        $(el).addClass("pc-error-field");
                    }
                    if (tag == "TEXTAREA") {
                        $(el).addClass("pc-error-field");
                    }
                    hasErrors = true;
                }
                if($(el).attr('type') == 'preferredLoginId') {
                    if($(this).val().includes("@"))
                    {
                        var pattern2 = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        if (!pattern2.test($(this).val())) {
    
                            $(el).addClass("pc-error-field");
                            hasErrors = true;
                        }
                    }
                    else
                    {
                        var pattern1 = /^[_A-z0-9]{3,}$/g;
                        if (!pattern1.test($(this).val())) 
                        {
                            $(el).addClass("pc-error-field");
                            hasErrors = true;
                        }
                    }
                }
                if ($(el).attr('type') == "email") {
                    var pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (!pattern.test($(this).val())) {

                        $(el).addClass("pc-error-field");
                        hasErrors = true;
                    }
                }
                if ($(el).attr('type') == "password") {
                    var pattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_]).{8,}$/;
                    if (!pattern.test($(this).val())) {

                        $(el).addClass("pc-error-field");
                        hasErrors = true;
                    }
                }
                if ($(el).is(':checkbox')) {
                    if (!$(el).is(":checked")) {
                        $(el).closest(".icheckbox_square-blue").addClass("pc-error-field");
                        hasErrors = true;
                    }
                }
            });

            return hasErrors;
        };
        //added for blocking canada drop ship address
        helpers.checkCandadaCustomers = function (form) {
            var blockCanOrderError = false;
            $(form).find(".pc-error-field").removeClass("pc-error-field");
            var dropShipCountry=$('#wby-drop-country').val();
            if (dropShipCountry == "CA") {
            	$("#error-field-har").hide();
            	blockCanOrderError = false;
            }else{
            	$("#error-field-har").hide();
            }
            return blockCanOrderError;
        };
        
        helpers.checkPassword = function (form) {
            error = true
            $(form).find(".pc-error-field").removeClass("pc-error-field");
            var password =  $("#registration-password").val();
            var confirmPassword =  $("#registration-confirm-password").val();
            if(password == confirmPassword)
            {
                error = false;
            }
            else
            {
                $("#registration-password").addClass("pc-error-field");
                $("#registration-confirm-password").addClass("pc-error-field");
            }
            return error;
        };

        //Added for store locator error forms
        helpers.checkLocaterFormForErrors = function (form) {
            var hasErrors = false;
            $(form).find(".pc-error-field").removeClass("pc-error-field");
            var states =  $(form).find("#cus-state").val();
            var city =  $(form).find("#cus-city").val();
            var zip = $(form).find("#cus-zip").val();
            if(states == "" && city == "" && zip == "" ){
            	$("#error-field-wby").show();
            	hasErrors = true;
            }else{
            	$("#error-field-wby").hide();
            }
            $(form).find("[pc-required-field]:visible").each(function (idx, el) {
                var trimmedValue = $(el).val();
               // $(el).val(trimmedValue);
                if (trimmedValue == "" ||  trimmedValue === null) {
                    var tag = $(el).prop("tagName");
                    if (tag == "SELECT") {
                        $(el).siblings(".select2-container").first().find(".select2-selection").addClass("pc-error-field");
                    }
                    if (tag == "INPUT") {
                        $(el).addClass("pc-error-field");
                    }
                    hasErrors = true;
                }
                if ($(el).attr('type') == "email") {
                    var pattern = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
                    if (!pattern.test($(this).val())) {

                        $(el).addClass("pc-error-field");
                        hasErrors = true;
                    }
                }
                if ($(el).is(':checkbox')) {
                    if (!$(el).is(":checked")) {
                        $(el).closest(".icheckbox_square-blue").addClass("pc-error-field");
                        hasErrors = true;
                    }
                }
            });
            return hasErrors;
        };

        helpers.removeErrorsDisplay = function () {
            $(".pc-error-field").removeClass("pc-error-field");
        };

        helpers.updateCharCountdown = function () {
            helpers.elements.charCountdown.trigger("keyup");
        };

        // countries and states, could be moved to separate service
        helpers.populateCountries = function (type) {
            return helpers._api.common.getCountries(type).then(function (res) {
                if (res && res.status == 200) {
                    helpers.context.countries = res.body;
                    helpers.renderCountries(type);
                    return res.body;
                } else {
                    console.log(res);
                }
            });
        };

        helpers.renderCountries = function (type) {
            var html = helpers.templates.countries(helpers.context);

            helpers.elements.getCountries(type).html(html);
            helpers._applyScript.base.select2();
        };

        helpers.populateStates = function (countryIso) {
            return helpers._api.common.getStates(countryIso).then(function (res) {
                if (res && (res.status == 200 || res.status == 210)) {
                    helpers.context.states = res.body;
                    helpers.renderStates();
                    return res.body;
                } else {
                    console.log(res);
                }
            });
        };

        helpers.renderStates = function () {
            var html = helpers.templates.states(helpers.context);
            helpers.elements.states.html(html);

            helpers._applyScript.base.select2();
        };

        // pager
        helpers.getPager = function (component) {
            var newPager = helpers.pagerFactory.getPager(component);

            return newPager;
        };

        helpers.populateFormWithHiddenFields = function (form, data) {
            if (!form || !data) return false;
            $(form).empty();
            for (var key in data) {
                var str = "<input type='hidden' name='" + key + "' value ='" + data[key] + "'>";
                $(form).append(str);
            }
        };

        helpers.clickAnchorLink = function (url) {
            var anchor = $("#pc-anchor");
            if (!anchor.length) {
                anchor = document.createElement("a");
                anchor.style.display = "none";
                anchor.setAttribute("id", "pc-anchor");
                anchor.setAttribute("target", "_blank");
                this._elements.body.append(anchor);
                anchor = $(anchor);
            }

            anchor.prop("href", url)[0].click();
        };

        helpers.handlers = {
            onCountryChange: function (countryIso) {
                helpers.populateStates(countryIso);
            },
            onControllerInitialized: function () {
                $(".modal").modal("hide");

                // hide navbar at small screens
                $('.navbar-collapse').collapse('hide');
            }
        };

        helpers.init = function () {

            helpers._bindings();
            helpers._events.registerHandlerAsLastOne("controllerInitialized", helpers.name, helpers.handlers.onControllerInitialized);
        };

        return helpers;

    };

    window.appComponents = appComponents;

})(window.appComponents || {});
